import React, { useEffect, useState } from 'react';
import WithStandardLayout from '@/layouts/withStandard.layout';
import LoginPage from '@/components/LoginPage/LoginPage';
import initializeIconLibrary from '@/utils/fontAwesomeLibrary';
import 'bootstrap/dist/css/bootstrap.min.css';
import useAccount from '@/hooks/useAccount';
import { buildServerSideProps } from '@/utils/server';

initializeIconLibrary();

const Login = () => {
  const { account } = useAccount();

  useEffect(() => {
    account.setNextPage('/');
  }, []);

  return <LoginPage />;
};

export const getServerSideProps = buildServerSideProps();

Login.getLayout = function getLayout(page) {
  return <WithStandardLayout host={page.props.host}>{page}</WithStandardLayout>;
};

export default Login;
